module.exports = __webpack_public_path__ + "media/images/beauty/card-desktop-fd6406adbd2d2dd09f27d1182fdad4b5.jpg";